export default __webpack_public_path__ + "static/media/159.a4485330.jpg";